import React from 'react';
import { translate } from 'react-i18next';
import { Carousel, Image } from 'react-bootstrap';

export class ImagePreviewSlider extends React.Component {
  renderImage(images) {
    return (
      <Carousel className="project-detail-carousel">
        {images.map(({ id, image }) => (<Carousel.Item key={`caro-${id}`}><Image src={image} /></Carousel.Item>))}
      </Carousel>
    );
  }

  renderNoContent() {
    const { t } = this.props;
    return (
      <div style={{ display: 'flex', justifyContent: 'center', height: 450 }}>
        <span style={{ alignSelf: 'center' }}>{t('no image')}</span>
      </div>
    );
  }

  render() {
    const { images } = this.props;
    return images ? this.renderImage(images) : this.renderNoContent();
  }
}

export default translate('translations')(ImagePreviewSlider);



// WEBPACK FOOTER //
// ./src/components/project_detail/ImagePreviewSlider.js